import { render, staticRenderFns } from "./TrailerIdentifierCard.vue?vue&type=template&id=461aff26&"
import script from "./TrailerIdentifierCard.vue?vue&type=script&lang=js&"
export * from "./TrailerIdentifierCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports